
import React, { Component } from "react";
import ReactHtmlParser from 'react-html-parser';
import { encode as base64_encode } from 'base-64';
import LaunchDisplay from "../../Publish/LaunchDisplay";
import WebPageCompan from "../../Publish/WebPageCompan";
import Embed from "../../Publish/Embed";
import ShareUrls from './ShareUrls';
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";

class CodeSection extends Component {
    state = {
       shareLink: null
    }

    componentDidMount(){
      try{
        const { wallData } = this.props;
        if(wallData && Object.keys(wallData).length > 0 && wallData.wall){
            const wallName = wallData.wall.name;
            const wallId = wallData.wallId;
            const timeStamp = new Date() / 1000 | 0;
            const value = `${wallName}---${wallId}&${timeStamp}`;
            const sharelink = base64_encode(value);
            this.setState({ shareLink: sharelink });
        }
      }catch(ex){
        console.log(ex,"es")
      }
    }

    render() {
        const { useCaseData, wallData, product, selectProduct, widgetOptions, useCase } = this.props;
        
        return wallData ?
            <>
                <div className="code-publish">

                    {product == 'display' ? useCaseData && Object.keys(useCaseData).length > 0 &&
                       <div className="d-flex flex-wrap h-100">
                            <div className="col-lg-6 col-12">{(useCase == 'events' && useCaseData.active != 8) ? 
                                <div className="publish_steps">
                                    <Embed />
                                    <h6 className="mb-4 ms-5">OR</h6>
                                    <div className="form-group mb-lg-10 mb-6">
                                        <h6 className="mb-4 ms-5"> B. Copy The Display Wall URL</h6>
                                        <LaunchDisplay wallData={wallData} lunch={4} lunchUrlParm={``} />
                                    </div>
                                    <div className="form-group mb-lg-10 mb-6">
                                        <h5 className="mb-4">Step 2: {useCaseData.Step2}</h5>
                                        {ReactHtmlParser(useCaseData.content)}
                                    </div>
                                </div> : <DisplayLaunch useCaseData={useCaseData} wallData={wallData} />}
                            </div>
                           {this.state.shareLink && wallData && wallData.wall && wallData.wall.Personalization && Object.keys(wallData.wall.Personalization).length > 0 && wallData.wall.Personalization.interactive ? <div className="col-lg-6 col-12"><ShareUrls wallUrl={wallData.wall.url} wallId={wallData.wallId} shareLink={this.state.shareLink}/></div> : null}
                       </div>
                       :
                        <div className="tab-content"> {widgetOptions.map((curr, index) => {
                            let { name, title, popupID, classActive } = curr;
                            return (
                                <div
                                    key={index}
                                    className={`tab-pane fade ${classActive}`}
                                    id={popupID}
                                    role="tabpanel"
                                    aria-labelledby={`${name}-tab`}
                                >
                                    <div className="publish_steps">
                                        <h4 className="font-weight-bolder text-dark mb-5 mb-lg-8">
                                            {title}
                                        </h4>
                                        <WebPageCompan getPage={3} index={index} embedTag={false} name={name} />
                                    </div>
                                </div>

                            )
                        })}
                        </div>
                    }
                </div>
                {useCaseData && Object.keys(useCaseData).length > 0 && <div className="f-between flex-wrap mt-3">
                    <div className="d-flex align-items-center flex-wrap mb-md-0 mb-2">
                        Need help?
                        <a id="tb_vid1" href={product == 'display' ? `https://vimeo.com/${useCaseData.video}` : `https://player.vimeo.com/video/${useCaseData.videoURL}`} data-lity className="video_btn btn btn-text p-0 ms-2 text-dark btn-clean lity_lightbox" data-factors-click-bind="true">
                            <FontAwesomeIcon type={'light'} icon={'circle-play'} iconClass={'me-2 text-dark-500'} /> Watch Video
                        </a>
                        <span className="mx-2 text-muted">Or</span>
                        <a href={product == 'display' ? `https://socialwalls.com/support/${useCaseData.linkUrl}` : `https://taggbox.com/support/how-to-embed-widget-on-${useCaseData.name.toLowerCase()}-website`} target="_blank" className="btn btn-text p-0 text-dark-75 btn-clean text-underline" data-factors-click-bind="true">Learn More</a>
                    </div>
                    <div className="preview-publish">
                        <Button variant="primary" id="preview_btn" className="preview_btn" data-factors-click-bind="true" onClick={() => selectProduct(product)}>Preview</Button>
                    </div>
                </div>}
            </>
            : null
    }
}

export default CodeSection;

const DisplayLaunch = ({ useCaseData, wallData }) => {
    return <div className={`tab-pane item-fadeIn active`} id={useCaseData.icon} role="tabpanel" aria-labelledby={`${useCaseData.icon}-tab`}>
        <div className="form-group mb-lg-10 mb-6">
            <h4 className="mb-6 font-weight-boldest">{useCaseData.heading}</h4>
        </div>
        <div className="form-group mb-lg-10 mb-6">
            <h5 className="mb-4">Step 1 : {useCaseData.Step1 ? useCaseData.Step1 : 'Copy The Display Wall URL'}  </h5>
            <LaunchDisplay wallData={wallData} lunch={useCaseData.lunch} lunchUrlParm={useCaseData.lunchUrlParm} />
        </div>

        <div className="form-group mb-lg-10 mb-6">
            <h5 className="mb-4">Step 2: {useCaseData.Step2}</h5>
            {ReactHtmlParser(useCaseData.content)}
        </div>
    </div>
}
